export default __webpack_public_path__ + "static/media/11.7a2d6c1a.jpg";